import axios from 'axios'

/**
 * @param {"get"|"post"|"put"|"patch"|"delete"} method
 * @param {URL} url
 * @param {{[key: string]: string}|undefined} headers
 * @param {string|object|ArrayBuffer|ArrayBufferView|URLSearchParams|FormData|File|Blob|null} data
 * @param {object|URLSearchParams|undefined} params
 * @param {boolean} withCredentials
 * @param {boolean} crossOrigin
 * @returns {Promise<*>}
 */
export const fetchDataFromApi = ({
  method = 'get',
  url,
  headers,
  data = null,
  params,
  withCredentials = false,
  crossOrigin = false,
}) => {
  return new Promise((resolve, reject) => {
    fetchData({
      method,
      url,
      data,
      params,
      headers,
      withCredentials,
      crossOrigin,
    })
      .then((response) => {
        const { status } = response
        if (status === 'success') {
          resolve(response.data)
        } else {
          reject(response)
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * @param {"get"|"post"|"put"|"patch"|"delete"} method
 * @param {URL} url
 * @param {{[key: string]: string}|undefined} headers
 * @param {string|object|ArrayBuffer|ArrayBufferView|URLSearchParams|FormData|File|Blob|null} data
 * @param {object|URLSearchParams|undefined} params
 * @param {boolean} withCredentials
 * @param {boolean} crossOrigin
 * @param {string} responseType
 * @returns {Promise<*>}
 */
export const fetchData = ({
  method = 'get',
  url,
  headers,
  data = null,
  params,
  withCredentials = false,
  crossOrigin = false,
  responseType = 'json',
}) => {
  return new Promise((resolve, reject) => {
    axios({
      method,
      url,
      data,
      params,
      headers,
      withCredentials,
      crossOrigin,
      responseType,
    })
      .then((response) => {
        const { status } = response
        if (status === 200) {
          resolve(response.data)
        } else {
          reject(response)
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}
